const f = ["#b2182b", "#f7f7f7", "#2166ac"], c = ["#b2182b", "#f6b395", "#f7f7f7", "#9cc7e0", "#2166ac"], E = [
  "#b2182b",
  "#ef8a62",
  "#fddbc7",
  "#f7f7f7",
  "#d1e5f0",
  "#67a9cf",
  "#2166ac"
];
export {
  f as DIVERGING_RED_BLUE_3,
  c as DIVERGING_RED_BLUE_5,
  E as DIVERGING_RED_BLUE_7
};
//# sourceMappingURL=index.es5694.js.map
